import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowUpIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.96 19V6.98L5.72 12.28L4.44 11L12 3.44L19.56 11L18.28 12.28L13.04 6.98V19H10.96Z" />
    </SvgIcon>
  );
});
